module.exports = __webpack_public_path__ + "static/media/dontcumyet.de316a32.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/dontcumyet.wav
// module id = 509
// module chunks = 0